import { render, staticRenderFns } from "./serviceSectionCard.vue?vue&type=template&id=718905fa&scoped=true"
import script from "./serviceSectionCard.vue?vue&type=script&lang=js"
export * from "./serviceSectionCard.vue?vue&type=script&lang=js"
import style0 from "./serviceSectionCard.vue?vue&type=style&index=0&id=718905fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "718905fa",
  null
  
)

export default component.exports